module.exports = __webpack_public_path__ + "static/media/invitation_active.46c75c21.svg";